<nav class="pagination" *ngIf="totalPages > 1">
  <button class="page-control prev" [disabled]="page === 1" (click)="onPageChange(page - 1)">
    Previous
  </button>

  <div class="page-numbers">
    <button
      *ngFor="let p of pages"
      class="page-number"
      [class.active]="p === page"
      (click)="onPageChange(p)"
    >
      {{ p }}
    </button>
  </div>

  <button
    class="page-control next"
    [disabled]="page === totalPages"
    (click)="onPageChange(page + 1)"
  >
    Next
  </button>
</nav>
